export default "__VITE_ASSET__BDWO3RhC__"